
import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { ISolCustomerOrderDocument } from "@/entities";
import DetailContainer from "@/components/orders/DetailContainer.vue";
import DetailAmounts from "@/components/orders/DetailAmounts.vue";

@Component({
  name: "detail-consignment",
  components: { DetailAmounts, DetailContainer },
})
export default class DetailConsignment extends Vue {
  @Prop({ required: true })
  item!: ISolCustomerOrderDocument;
  isVisibleDetailConsignment = false;

  constructor() {
    super();
  }
}
